import { ColumnsFactory } from "../../../../../shared/components/Grid/functions";

export const getColumnDefs = () => {
  return [
    ColumnsFactory.DateColumn("Fecha", "fecha"),
    ColumnsFactory.DecimalColumn("Horas Estimadas", "horasEstimadas", {ipkTotalizar: true}),
    ColumnsFactory.DecimalColumn("Horas Imputadas", "horasImputadas", {ipkTotalizar: true}),
    ColumnsFactory.DecimalColumn("Horas Restantes", "horasRestantes",{ipkTotalizar: true})
  ];
};